import React from 'react';
import BaseHeader from './BaseHeader';
import { Image } from 'react-native';
import Images from '../../../Images';
import { NativeStackHeaderProps } from '@react-navigation/native-stack';
import Stack from '../Stack';
import { colors } from '../../../utils/theme';

export type DesktopLogoHeaderOwnProps = {};

export type DesktopLogoHeaderProps = DesktopLogoHeaderOwnProps & NativeStackHeaderProps;

const DesktopLogoHeader: React.FC<DesktopLogoHeaderProps> = (props) => {
    return (
        <BaseHeader
            {...props}
            height={60}
            hideBackButton
            fullWidth
            style={{
                backgroundColor: colors.White,
            }}
            desktopContent={
                <Stack horizontal fullWidth align="center" justify="center" testID="desktop-logo-header">
                    <Image
                        alt="primary record logo"
                        style={{ width: 187, height: 25 }}
                        resizeMode="contain"
                        source={Images.PrimaryRecordLogoDarkV2}
                        defaultSource={Images.PrimaryRecordLogoDarkV2}
                    />
                </Stack>
            }
        />
    );
};

export default React.memo(DesktopLogoHeader);
